<template>
  <v-content>
    <AppBar title="Vändstäd" />

    <v-container class="pb-8">
      <v-row no-gutters>
        <v-col>
          <v-dialog
            ref="dialog"
            v-model="dateModal"
            :return-value.sync="filter.date"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                filled
                v-model="filter.date"
                label="Datum"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="sv"
              first-day-of-week="1"
              v-model="filter.date"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateModal = false"
                >Avbryt</v-btn
              >
              <v-btn
                text
                color="primary"
                @click="$refs.dialog.save(filter.date)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>

          <v-row>
            <v-col>
              <v-text-field
                filled
                label="Tågnummer"
                type="number"
                v-model.number="filter.train_number"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="filter.train_number" no-gutters>
        <v-col>
          <p>Övergripande text</p>
          <v-radio-group v-model="model.requirement">
            <v-radio
              label="På denna avgång saknas vändstäd men behov finnes."
              value="På denna avgång saknas vändstäd men behov finnes."
            ></v-radio>
            <v-radio
              label="På denna avgång ska vändstäd göras vid ankomst. Inget behov föreligger vid detta tillfälle."
              value="På denna avgång ska vändstäd göras vid ankomst. Inget behov föreligger vid detta tillfälle."
            ></v-radio>
          </v-radio-group>

          <p>Tjänstgör i:</p>
          <v-radio-group v-model="model.perform_at">
            <v-radio
              v-for="position in positions"
              :key="position"
              :label="position"
              :value="position"
            ></v-radio>
          </v-radio-group>
          <v-textarea filled label="Kommentar" v-model="model.comment" />
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col>
          <v-card tile>
            <v-card-text class="d-flex align-center">
              <v-icon class="mr-4">mdi-information-outline</v-icon>
              Sök på tågnummer för att visa formuläret...
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="showValidationModal" max-width="290">
      <ValidationModal
        :errors="validationErrors"
        @close="showValidationModal = false"
        v-if="showValidationModal"
      />
    </v-dialog>
    <v-footer fixed color="white" elevation="2" class="pa-2">
      <v-spacer></v-spacer>
      <v-btn
        :disabled="
          !filter.train_number || filter.train_number.toString().length < 4
        "
        :loading="pendingRegister"
        tile
        color="primary"
        @click="onRegister"
        >Registrera vändstäd</v-btn
      >
    </v-footer>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar.vue'

import ValidationModal from '@/components/ValidationModal'
import { format } from 'date-fns'
import gql from 'graphql-tag'

export default {
  name: 'Cleaning',

  components: {
    AppBar,
    ValidationModal
  },

  data: () => ({
    advertisedTrainnumber: null,
    showValidationModal: false,
    pendingRegister: false,
    dateModal: false,
    positions: ['M1', 'M2', 'M3'],
    model: {
      requirement: null,
      perform_at: null,
      comment: null
    },
    filter: {
      train_number: null,
      date: format(new Date(), 'yyyy-MM-dd')
    }
  }),

  methods: {
    async onRegister() {
      if (this.validationErrors.length) {
        return (this.showValidationModal = true)
      }

      this.pendingRegister = true

      const { data } = await this.$apollo.mutate({
        mutation: gql`
          mutation createCleaning($payload: CreateCleaningInput!) {
            createCleaning(payload: $payload) {
              date
              train_number
              requirement
              perform_at
              comment
            }
          }
        `,

        variables: {
          payload: {
            train_number: this.filter.train_number,
            date: this.filter.date,
            ...this.model
          }
        }
      })

      this.$store.set('cleaning/data', data.createCleaning)
      this.$router.push('/cleaning-completed')
      this.pendingRegister = false
    }
  },

  computed: {
    validationErrors() {
      const errors = []

      if (!this.model.perform_at) {
        errors.push('Position ej vald')
      }
      if (!this.model.requirement) {
        errors.push('Övergripande text ej vald')
      }

      //   if (!this.model.station) {
      //     errors.push('Station ej vald')
      //   }

      //   if (!this.model.position) {
      //     errors.push('Position ej vald')
      //   }

      //   if (this.model.canceled === null) {
      //     errors.push('Föregående tåg var inställt ej vald')
      //   }

      //   if (this.model.reduced === null) {
      //     errors.push('Indragen vagn ej vald')
      //   }

      return errors
    }
  }
}
</script>
